import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "model", "modelHidden",
    "variant", "variantHidden", "variantCol",
    "info", "typeName", "version", "weightRange", "cgRange", "wbm",
    "versionHidden"
  ]

  static values = { configs: Array }

  connect() {
    // If model is pre-selected (edit mode), populate variant dropdown and info
    const currentModel = this.modelHiddenTarget.value
    if (currentModel) {
      this.populateVariants(currentModel)
      this.updateInfo()
    }
  }

  modelChanged() {
    const model = this.modelTarget.value
    this.modelHiddenTarget.value = model

    this.populateVariants(model)
    this.variantHiddenTarget.value = ""

    this.updateInfo()
  }

  variantChanged() {
    this.variantHiddenTarget.value = this.variantTarget.value
    this.updateInfo()
  }

  populateVariants(model) {
    const variants = this.configsValue
      .filter(c => c.model === model && c.variant)
      .map(c => c.variant)

    if (variants.length > 0) {
      this.variantColTarget.style.display = ""
      const currentVariant = this.variantHiddenTarget.value

      let html = '<option value="">Base model (no variant)</option>'
      variants.forEach(v => {
        const selected = v === currentVariant ? " selected" : ""
        html += `<option value="${v}"${selected}>${v}</option>`
      })
      this.variantTarget.innerHTML = html
    } else {
      this.variantColTarget.style.display = "none"
      this.variantTarget.innerHTML = '<option value="">Base model (no variant)</option>'
      this.variantHiddenTarget.value = ""
    }
  }

  updateInfo() {
    const model = this.modelHiddenTarget.value
    const variant = this.variantHiddenTarget.value

    if (!model) {
      this.infoTarget.style.display = "none"
      return
    }

    // Find matching config: prefer exact variant match, fallback to base model
    let config = this.configsValue.find(c => c.model === model && c.variant === variant)
    if (!config && variant) {
      config = this.configsValue.find(c => c.model === model && !c.variant)
    }
    if (!config) {
      config = this.configsValue.find(c => c.model === model)
    }

    if (config) {
      this.infoTarget.style.display = ""
      const label = [config.manufacturer, model, variant].filter(Boolean).join(" ")
      this.typeNameTarget.textContent = label
      this.versionTarget.textContent = config.version || "—"
      this.versionHiddenTarget.value = config.version || ""

      if (config.weight_min && config.weight_max) {
        const minT = Math.round(config.weight_min / 1000)
        const maxT = Math.round(config.weight_max / 1000)
        this.weightRangeTarget.textContent = `${minT}t – ${maxT}t`
      } else {
        this.weightRangeTarget.textContent = "—"
      }

      if (config.cg_fwd != null && config.cg_aft != null) {
        this.cgRangeTarget.textContent = `${config.cg_fwd}% – ${config.cg_aft}%`
      } else {
        this.cgRangeTarget.textContent = "—"
      }

      this.wbmTarget.textContent = config.wbm || "—"
    } else {
      this.infoTarget.style.display = "none"
    }
  }
}
